import React from 'react';
import { Typography, Skeleton, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import TagList from './TagList';
import styles from '../Profile.module.css';

const { Title } = Typography;

interface ValuesSectionProps {
  values: string[];
  isLoading: boolean;
}

const ValuesSection: React.FC<ValuesSectionProps> = ({ values, isLoading }) => {
  const { t } = useTranslation();

  // Don't render if no values available
  if (!isLoading && (!values || values.length === 0)) {
    return null;
  }

  return (
    <Card className={styles.sectionCard} bordered={false}>
      <Title level={4} className={styles.sectionTitle}>
        {t('#Profile.values')}
      </Title>

      <Skeleton loading={isLoading} paragraph={{ rows: 2 }} active>
        <TagList items={values} />
      </Skeleton>
    </Card>
  );
};

export default ValuesSection;